<script>
  import { html } from 'common-tags';

  import ChoiceInput from './choice-input.svelte';
  import NumberRange from './number-range.svelte';

  // TODO temporary placeholder icons:
  const NONE = html`<svg
    width="1rem"
    height="1rem"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;"
  >
    <rect x="2" y="2" width="36" height="36" fill="none" stroke="currentcolor" stroke-width="4" />
  </svg>`;

  const SMALL = html`<svg
    width="1rem"
    height="1rem"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;"
  >
    <rect x="2" y="2" width="36" height="36" rx="8" fill="none" stroke="currentcolor" stroke-width="4" />
  </svg>`;

  const LARGE = html`<svg
    width="1rem"
    height="1rem"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;"
  >
    <rect x="2" y="2" width="36" height="36" rx="12" fill="none" stroke="currentcolor" stroke-width="4" />
  </svg>`;

  const ROUND = html`<svg
    width="1rem"
    height="1rem"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;"
  >
    <circle cx="20" cy="20" r="18" fill="none" stroke="currentcolor" stroke-width="4" />
  </svg>`;

  export let value;

  export let onChange = () => {};

  const options = [
    { value: '0rem', label: 'none', html: NONE },
    { value: '0.5rem', label: 'small', html: SMALL },
    { value: '1rem', label: 'large', html: LARGE },
    { value: '100rem', label: 'round', html: ROUND }
  ];
</script>

<NumberRange {...$$restProps} property="border-radius" {value} {onChange}>
  <ChoiceInput {value} {options} {onChange} />
</NumberRange>
